<template>
  <div class="detail-container">
    <div class="header">
      <van-nav-bar
        :placeholder="true"
        :fixed="true"
        left-arrow
        :title="navTitle"
        @click-left="$router.go(-1)"
      >
        <template #right>
          <img
             width="22px"
             height="18px"
            @click="showShare = true"
            src="../../assets/fenxiang-3.png"
            alt=""
          />
          <!-- <van-icon @click="showShare = true" name="share-o" size="18" /> -->
        </template>
      </van-nav-bar>
    </div>

    <div class="content" v-if="loading">
      <van-loading type="spinner" color="#333">加载中...</van-loading>
    </div>
    <div class="content" v-else-if="detailData">
      <!-- 内容 -->
      <div
        class="detail-content"
        v-if="detailData.content"
        v-html="detailData.content"
      ></div>
      <!-- link_url文章 -->
      <iframe
        v-if="detailData.link_url"
        class="detail-iframe"
        :src="detailData.link_url"
        frameborder="0"
      ></iframe>
      <van-empty v-else-if="!detailData.content" description="暂无文章内容" />
    </div>
    <div class="content error" v-else>
      <van-empty description="暂无数据" />
    </div>

    <van-share-sheet
      v-model="showShare"
      title="立即分享给好友"
      :options="options"
      @select="onSelect"
    />
  </div>
</template>

<script>
import checkDevice from "../../tools/app";
export default {
  data() {
    return {
      articleId: "",
      detailData: null,
      loading: false,
      showShare: false,
      options: [
        { name: "微信", icon: "wechat" },
        {
          name: "朋友圈",
          icon: "https://img.yzcdn.cn/vant/share-icon-wechat-moments.png",
        },
        { name: "复制链接", icon: "link" },
      ],
    };
  },
  computed: {
    navTitle() {
      return (this.detailData && this.detailData.title) || "详情";
    },
  },
  created() {
    const { articleId, item: itemStr } = this.$route.query;
    this.articleId = articleId;

    // 如果上个页面已传递完整的 item，优先使用以减少二次请求
    if (itemStr) {
      try {
        const parsed = JSON.parse(decodeURIComponent(itemStr));
        this.detailData = parsed;
        if (!this.articleId) {
          this.articleId = parsed.article_id || parsed.id || "";
        }
      } catch (err) {
        console.warn("解析传入的 item 失败:", err);
      }
    }

    if (this.articleId && !this.detailData) {
      this.getDetailData();
    }
  },
  methods: {
    // 根据articleId从后台列表中匹配详情
    onSelect(option) {
      let phone = checkDevice();
      // 判断设备系统的函数
      if (phone == "ios") {
        if (option.name == "微信") {
          // IOS系统并且选择的是微信支付
          window.webkit.messageHandlers.jsCallOCFunction2.postMessage([
            this.detailData,
            "1",
          ]);
        } else if (option.name == "朋友圈") {
          // IOS系统并且选择的是支付宝支付

          window.webkit.messageHandlers.jsCallOCFunction2.postMessage([
            this.detailData,
            "2",
          ]);
        } else if (option.name == "复制链接") {
          window.webkit.messageHandlers.jsCallOCFunction2.postMessage([
            this.detailData,
            "3",
          ]);
        } else {
          this.$toast.fail("未安装微信");
          return false;
        }
      } else if (phone == "android") {
        if (option.name == "微信") {
          // Android系统并且选择的是微信支付
          window.jsCallAndroid.jsCallOCFunction([
            JSON.stringify(this.detailData),
            "1",
          ]);
        } else if (option.name == "朋友圈") {
          // Android系统并且选择的是支付宝支付
          window.jsCallAndroid.jsCallOCFunction([
            JSON.stringify(this.detailData),
            "2",
          ]);
        } else if (option.name == "复制链接") {
          window.jsCallAndroid.jsCallOCFunction([
            JSON.stringify(this.detailData),
            "3",
          ]);
        } else {
          this.$toast.fail("未选择支付方式");
          return false;
        }
      } else {
        this.$toast.fail("未安装微信");
        return false;
      }
      this.showShare = false;
    },
  },
};
</script>

<style lang="less" scoped>
.detail-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  overscroll-behavior: none;
}

.van-nav-bar {
  padding-top: constant(safe-area-inset-top); /* 兼容旧的iOS版本 */
  padding-top: env(safe-area-inset-top); /* 兼容新的iOS版本 */
}

.content {
  flex: 1;
  padding: 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;

  align-items: stretch;
  justify-content: flex-start;
  overflow: hidden;
  &.error {
    padding-top: 50px;
  }
}

.detail-img {
  width: 100%;
  height: auto;
  border-radius: 8px;
  margin-bottom: 16px;
  object-fit: cover;
}

.detail-title {
  font-size: 20px;
  font-weight: bold;
  color: #333;
  margin-bottom: 12px;
  width: 100%;
  text-align: left;
}

.detail-content {
  font-size: 16px;
  color: #666;
  line-height: 1.6;
  width: 100%;
  text-align: left;
  word-wrap: break-word;
  padding: 12px 16px;
  box-sizing: border-box;
  overflow-y: auto;
  flex: 1;
  -ms-overflow-style: none; /* IE/Edge */
  scrollbar-width: none; /* Firefox */

  &::-webkit-scrollbar {
    display: none; /* Chrome/Safari */
  }

  /deep/ img {
    max-width: 100%;
    height: auto;
  }

  /deep/ p {
    margin-bottom: 12px;
  }
}

.detail-info {
  font-size: 14px;
  color: #999;
  margin-top: 16px;
  width: 100%;
  text-align: left;
}

.detail-iframe {
  flex: 1;
  width: 100%;
  height: 100%;
  border: none;
  overflow: hidden;
  -ms-overflow-style: none; /* IE/Edge */
  scrollbar-width: none; /* Firefox */

  &::-webkit-scrollbar {
    display: none; /* Chrome/Safari */
  }
}

/deep/.van-nav-bar .van-icon {
  color: black;
  font-size: 18px;
}
</style>
